import { GetParameterCommand, GetParameterCommandOutput, SSMClient } from '@aws-sdk/client-ssm';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';
import { logger } from 'src/logger';
import { CognitoService } from 'src/services/aws/CognitoService';

export class SSMService {
  private static client: SSMClient | null = null;

  private static getSSMClient(): SSMClient {
    if (this.client) return this.client;
    this.client = new SSMClient({
      region: ENVIRONMENT_VARIABLES.env.Region,
      credentials: CognitoService.credentialProvider
    });
    return this.client;
  }

  public static async retrieveParameter(parameterName: string): Promise<string> {
    const ssmClient = this.getSSMClient();
    const command = new GetParameterCommand({ Name: parameterName, WithDecryption: true });
    const response: GetParameterCommandOutput = await ssmClient.send(command);
    if (!response.Parameter?.Value) logger.error(`Unable to load parameter from AWS Systems Manager Parameter Store with key ${parameterName}`);
    return response.Parameter?.Value || '';
  }
}
